import { cloneDeep } from 'lodash';
import { Editor } from '@meitu/saas-editor-core';
import { ImageEnhancePlugin } from '@meitu/saas-editor-core/es/plugins/image-enhance';

export const useBatchActionHooks = () => {
    const batchAction = async (
        editor: Editor,
        newParams: any,
        onStageLoading?: (stageIndex: number, isBatch: boolean) => void,
        setIsDisable?: (isDisable: boolean) => void,
        batchSetIsLoading?: (stageIndex: number[]) => void,
    ) => {
        setIsDisable?.(true);
        const imageEnhance = editor.getInstance(ImageEnhancePlugin);

        editor.tip.showMask({
            loading: true,
        });
        const stageList = editor.stage.getRenderStageList();
        batchSetIsLoading?.(stageList);
        const mainLayer = editor.active.getMainLayer();
        if (mainLayer) {
            mainLayer.__renderEnhanceCanvas = false;
            mainLayer.__useNavigatorRender = false;
            editor.stage.updateLayer(cloneDeep(mainLayer));
        }

        await new Promise((resolve) => {
            setTimeout(async () => {
                await imageEnhance.basicEnhance.batchAction(newParams, onStageLoading);
                const originLayer = imageEnhance.getState().originLayer;
                if (originLayer) {
                    await imageEnhance.basicEnhance.create(originLayer, undefined, true);
                    await imageEnhance.basicEnhance.action({});
                }

                onStageLoading?.(stageList[0], false);
                editor.tip.hideMask();
                setIsDisable?.(false);
                resolve(true);
            }, 10);
        });

        editor.tip.hideMask();
        setIsDisable?.(false);
    };

    return {
        batchAction,
    };
};
